import styled from 'styled-components';
import { Typography } from 'antd';

const { Text } = Typography;

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;
  
  &:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const CardTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 16px;
  color: #1F2937;
  text-align: center;
`;

export const TotalSubscription = styled(Text)`
  display: flex;
  justify-content: left;
  align-items: left;
  color: #2563EB;
  font-size: 12px;
  margin-top: 16px;
  display: block;
`;

export const StatItem = styled.div`
  display: flex;
  justify-content: left;
  align-items: left;
  align-content: left;
  margin-top: 8px;
  font-size: 12px;
`;

export const ColorIndicator = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${props => props.color};
`;

export const AssessmentItem = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
`;